/* OTCD hero slider (sections/otcd-hero-slider.liquid).
   Tabs, prev/next, arrow keys, autoplay that pauses on hover and focus,
   and no autoplay under prefers-reduced-motion. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (!root || root.otcdHero) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('.otcd-hero__slide'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.otcd-hero__tab'));
    var tablist = root.querySelector('.otcd-hero__tabs');
    if (slides.length < 2 || tabs.length !== slides.length) return;

    var seconds = parseInt(root.getAttribute('data-seconds'), 10) || 7;
    var wantsAutoplay = root.getAttribute('data-autoplay') === 'true';
    var current = 0;
    var timer = null;
    var paused = false;
    var editorHold = false;

    function autoplayOn() {
      return wantsAutoplay && !editorHold && !(reduceMotion && reduceMotion.matches);
    }

    function restartFill(tab) {
      var fill = tab.querySelector('.otcd-hero__fill');
      if (!fill) return;
      fill.style.animation = 'none';
      void fill.offsetWidth;
      fill.style.animation = '';
    }

    function schedule() {
      clearTimeout(timer);
      var on = autoplayOn();
      root.classList.toggle('is-autoplay', on);
      if (on && !paused) {
        timer = setTimeout(function () {
          go(current + 1, false);
        }, seconds * 1000);
      }
    }

    function go(index, focusTab) {
      var n = slides.length;
      current = ((index % n) + n) % n;
      for (var i = 0; i < n; i++) {
        var on = i === current;
        slides[i].classList.toggle('is-active', on);
        if (on) slides[i].removeAttribute('inert');
        else slides[i].setAttribute('inert', '');
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].tabIndex = on ? 0 : -1;
        restartFill(tabs[i]);
      }
      if (focusTab) tabs[current].focus();
      schedule();
    }

    function setPaused(value) {
      paused = value;
      root.classList.toggle('is-paused', value);
      if (value) clearTimeout(timer);
      else schedule();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        go(i, false);
      });
    });

    tablist.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(current + 1, true);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(current - 1, true);
      } else if (e.key === 'Home') {
        e.preventDefault();
        go(0, true);
      } else if (e.key === 'End') {
        e.preventDefault();
        go(slides.length - 1, true);
      }
    });

    var prev = root.querySelector('[data-otcd-prev]');
    var next = root.querySelector('[data-otcd-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1, false); });
    if (next) next.addEventListener('click', function () { go(current + 1, false); });

    root.addEventListener('mouseenter', function () { setPaused(true); });
    root.addEventListener('mouseleave', function () {
      if (!root.contains(document.activeElement)) setPaused(false);
    });
    root.addEventListener('focusin', function () { setPaused(true); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget) && !root.matches(':hover')) setPaused(false);
    });

    if (reduceMotion && reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', schedule);
    }

    root.otcdHero = {
      select: function (el) {
        var i = slides.indexOf(el);
        if (i > -1) {
          editorHold = true;
          go(i, false);
        }
      },
      release: function () {
        editorHold = false;
        schedule();
      },
      destroy: function () {
        clearTimeout(timer);
      }
    };

    schedule();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-otcd-hero]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-otcd-hero]');
    if (root && root.otcdHero) root.otcdHero.destroy();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-otcd-hero]');
    if (root && root.otcdHero) root.otcdHero.select(e.target);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest('[data-otcd-hero]');
    if (root && root.otcdHero) root.otcdHero.release();
  });
})();
